import axios from "axios";
import { FastenCallbackMode } from "./FastenLoaderService";
export const getFastenApiMode = (isSandbox) => (isSandbox ? FastenCallbackMode.TEST : FastenCallbackMode.LIVE);
export const getFastenPublicId = (isSandbox, environment) => isSandbox ? environment.FASTEN_NONPRODUCTION_PUBLIC_ID : environment.FASTEN_PRODUCTION_PUBLIC_ID;
export class FastenSearchService {
    constructor(environment) {
        this.environment = environment;
    }
    async search(query, apiMode, publicId, filters, searchAfter) {
        var _a;
        const body = {
            query,
        };
        if (filters === null || filters === void 0 ? void 0 : filters.locations) {
            body.locations = filters.locations;
        }
        if ((filters === null || filters === void 0 ? void 0 : filters.sortBy) === "location") {
            body.sortBy = "location";
            if ((_a = filters.sortByOpts) === null || _a === void 0 ? void 0 : _a.locationZipcodes) {
                body.sortByOpts = { locationZipcodes: filters.sortByOpts.locationZipcodes };
            }
        }
        if (searchAfter) {
            body.searchAfter = searchAfter;
        }
        const response = await axios.post(`${this.environment.FASTEN_API_BASE_URL}/v1/bridge/catalog/search?api_mode=${apiMode}&public_id=${publicId}`, body);
        return response.data;
    }
}
